export default "__VITE_ASSET__71fc6111__"